import { useBreakpoint } from '@vivino/js-react-common-ui';
import cx from 'classnames';
import React from 'react';

import styles from './indicatorBar.scss';

interface IndicatorBarProps {
  className?: string;
  minValue?: number;
  maxValue?: number;
  value?: number;
}

export const IndicatorBar = ({ className, minValue, maxValue, value }: IndicatorBarProps) => {
  const { isDesktop } = useBreakpoint();

  const indicatorWidth = isDesktop ? 15 : 20;

  function calculateMeterPosition() {
    const tastePercentage = ((value - minValue) / (maxValue - minValue)) * 100;

    const halfIndicatorWidth = indicatorWidth / 2;
    const positionAdjustedByStartingPoint = tastePercentage - halfIndicatorWidth;

    if (positionAdjustedByStartingPoint < 0) {
      return '0';
    }
    if (positionAdjustedByStartingPoint > 100 - indicatorWidth) {
      return 100 - indicatorWidth + '%';
    }
    return positionAdjustedByStartingPoint + '%';
  }

  return (
    <div className={cx(styles.meter, className)}>
      <span
        className={styles.progress}
        style={{
          width: indicatorWidth + '%',
          left: calculateMeterPosition(),
        }}
      />
    </div>
  );
};

export default IndicatorBar;
